import React from "react";
import Icon from "../../components/Icon";

/**
 * Faixa da documentação. Fica no topo do painel, fora do bloco "O que é a API?",
 * porque é a primeira coisa que um dev procura ao abrir a página — se estivesse
 * dentro da introdução (que fica no fim), ficaria abaixo da dobra.
 * A faixa inteira é clicável, com o CTA só reforçando a affordance.
 */
export const DocsBanner = ({ url, label }) => (
    <a className="api-docs-banner" href={url} target="_blank" rel="noopener noreferrer">
        <span className="api-docs-banner__icon">
            <Icon name="knowledgeBase" size={22} strokeWidth={1.8} />
        </span>
        <span className="api-docs-banner__texts">
            <strong>Documentação da API</strong>
            <span className="api-docs-banner__sub">
                Todos os recursos, os campos de cada um, exemplos de payload e teste
                direto no navegador.
            </span>
            {label &&
                <span className="api-docs-banner__url">{label}</span>
            }
        </span>
        <span className="api-docs-banner__cta">
            Abrir
            <Icon name="external-link" size={16} strokeWidth={2.25} />
        </span>
    </a>
);

export default DocsBanner;
